import localizedCountries from 'localized-countries';
import deData from 'localized-countries/data/de';
import moment from 'moment-timezone';

const env = process.env.NODE_ENV;
const countries = localizedCountries(env === 'test' ? 'de' : deData);

export default {
  localeCodes: ['de'],

  currency: { code: 'EUR', symbol: '€' },

  saleCommands: [
    'whitelisting',
    'edit',
    'preview',
    'previewPdf',
    'delete',
    'close',
    'overview',
    'download',
    'manage',
    'notifications',
    'settings',
    'messaging',
    'inviteSeller',
  ],

  roundCommands: ['bidding-history', 'start', 'edit', 'open', 'stop'],

  durationTypes: ['fixed', 'flexible'],

  roundTypes: ['open_bidding', 'sealed_bidding'],

  // roundTypeBadges: {
  //   incremental_auction: ['new'],
  //   simple_offer: ['new'],
  // },

  roundCostHighlight: {},

  roundHideValidity: false,
  roundCanChangeDurationType: false,
  roundDefaultPreviewDays: 1,
  roundDefaultDurationInDays: 7,
  roundDefaultOfferValidityExtensionInDays: 7,
  roundShowInvitedCustomersCount: true,
  roundShowRedButtonPrice: false,
  roundShowBidSteps: true,
  roundShowDefaultBidSteps: true,
  roundAllowShowBidsBelowStartingPrice: true,

  salutationTypes: ['mr', 'mrs'],

  titleTypes: ['doctor', 'master'],

  salePropertyTypes: ['house', 'flat', 'property', 'office', 'business'],

  maritalStatuses: ['none', 'single', 'married', 'divorced', 'widowed'],

  provisionTypes: ['default', 'none', 'fixed_amount', 'fixed_percentage'],

  depositTypes: ['none', 'fixed_amount', 'percentage'],

  handoverTypes: [
    'land_register',
    'money_transfer',
    'key_handover',
    'sale_contract',
  ],

  pepTypes: ['no', 'yes', 'family', 'related'],

  moneyFieldFixedDecimalZeroes: 0,

  uploadTypes: [], // all available upload types
  defaultUploadTypes: [], // default preselected upload types
  requiredUploadTypes: [], // required upload types (=always selected, cannot be unselected)
  enableOptionalUploads: false,

  saleCreateRequireTC: true, // require T&C checkbox on sale import/create panel

  saleActions: [
    'award',
    'awardAll',
    'confirmAward',
    'increase',
    'rejectAll',
    'duplicate',
  ],

  // total number of pages in sale edit
  saleEditTotalPages: 3,

  // if true than the last page is docs, otherwise all of them are content only
  saleEditDocs: true,

  hideSaleEditGuide: false,

  csvImportDefaultEncoding: null,

  mlsTypes: ['none'],

  bulkRegistrationEnableCheckboxes: true,

  messagingTemplates: {
    cust_message: ['subject', 'text'],
  },

  messagingAudienceTypes: ['everyone', 'bidders', 'non_bidders'],

  defaultSaleOfferData: {},

  // sale = SaleEditStore
  getRequiredDocumentTypes(sale, offerData) {
    return [];
  },

  getRegistrationScheme(sale, t) {
    let scheme = {
      email: {
        title: t('Email'),
        type: 'email',
        required: true,
        target: 'buyerData.buyer_email',
        headers: [t('Email'), 'email', 'e-mail'],
      },
      phone: {
        title: t('Phone number'),
        type: 'phone',
        target: 'buyerData.buyer_phone',
        headers: [t('Phone number'), 'phone'],
      },
      salutation: {
        title: t('Salutation'),
        type: 'dropdown',
        options: this.salutationTypes,
        required: true,
        target: 'buyerData.buyer_salutation',
        headers: [t('Salutation'), 'salutation'],
      },
      title: {
        title: t('Title'),
        type: 'combobox',
        options: this.titleTypes,
        target: 'buyerData.buyer_title',
        headers: [t('Title'), 'title'],
      },
      firstName: {
        title: t('First name'),
        type: 'textfield',
        required: true,
        target: 'buyerData.buyer_firstName',
        headers: [t('First name'), 'first name', 'given name'],
      },
      lastName: {
        title: t('Last name'),
        type: 'textfield',
        required: true,
        target: 'buyerData.buyer_lastName',
        headers: [t('Last name'), 'last name', 'surname'],
      },
    };
    if (this.localeCodes.length > 1) {
      scheme.locale = {
        title: t('Locale'),
        type: 'dropdown',
        options: this.localeCodes,
        required: true,
        target: 'buyerData.buyer_locale',
      };
    }
    return scheme;
  },

  createOffer(sale, round, withBuyerData = true) {
    const buyerData = withBuyerData
      ? {
          buyer_locale: sale ? sale.locale : this.localeCodes[0],
          buyer_country: countries.get('DE'),
          buyer_country_code: 'DE',
        }
      : {};
    return {
      locale: sale ? sale.locale : this.localeCodes[0],
      buyerData,
      offerData: {
        offer_validity:
          sale && round && round.definition.offerValidityUntil
            ? moment(round.definition.offerValidityUntil).toDate()
            : undefined,
        currency_code: sale.currencyCode,
        required_uploads: [],
        optional_uploads: [],
      },
      triggerNotification: false,
      bidPlacedAt: null,
    };
  },
};



// WEBPACK FOOTER //
// ./src/app/config.js